import { defineStore } from "pinia";
import Services from '@/services/sutting/levelTwoServices'
import { mapList, mapLevelTwo } from '@/helpers/mapFuncs'

export const useLevelTwoStore = defineStore("levelTwo", {
persist: true,
state:()=>({
    levelTwo: {},
    levelTwos: [],
}),
getters : {
    getLevelTwo() {
        return mapLevelTwo(this.levelTwo)
    },
    getLevelTwos() {
        return this.levelTwos.map(mapLevelTwo)
    },
    getLevelTwosList() {
        return this.levelTwos.map(mapList)
    }
},
actions : {
    /** Start Sets */
    setLevelTwo(levelTwo) {
        this.levelTwo = levelTwo
    },
    setLevelTwos(levelTwos) {
        this.levelTwos = levelTwos
    },
    /** End Sets */

    /** Start Actions */
    get(id) {
        return Services.get(id)
        .then((response)=>{
            this.setLevelTwo(response.data.data)
            return response
        })
    },
    getAll(data) {
        return Services.getAll(data)
        .then((response)=>{
            this.setLevelTwos(response.data.data??[])
            return response
        })
    },
    add(data){
        return Services.add(data)
        .then((response)=>{
            this.levelTwos.push(response.data.data)
            return response
        })
    },
    edit(id, data){
        return Services.edit(id, data)
        .then((response)=>{
            this.levelTwos[this.levelTwos.findIndex((x)=>x.id == id)] = response.data.data
            return response
        })
    },
    delete(id){
        return Services.delete(id)
        .then((response)=>{
            this.levelTwos = this.levelTwos.filter((x)=>x.id != id)
            return response
        })
    },
    /** End Actions */
}
});
